import classNames from "classnames";

import { ReactComponent as LeftArrow } from "../../assets/ic-left-arrow.svg";

import styles from "./index.module.scss";

const BackButton = ({ onClick, className }) => {
  return (
    <div className={classNames(className, styles.container)} onClick={onClick}>
      <LeftArrow className="text-primary" />
    </div>
  );
};

export default BackButton;
